module.exports = __webpack_public_path__ + "static/media/om_wrinkles_fine.c5bd5af2.png";